export const AVAILABILITY_BLOCKS_GET_ALL = '/availabilityBlocks/getAll';
export const CONFIGURATION_GET = '/configuration/get';
export const CONFIGURATIONS_GET = '/configurations/get';
export const EXCHANGE_RATES_GET_ALL = '/exchangeRates/getAll';
export const ENTERPRISES_GET_PAYMENT_CONFIGURATION = '/enterprises/getPaymentConfiguration';
export const PAYMENT_CARDS_AUTHORIZE = '/paymentCards/authorize';
export const PROMOTED_SERVICES_GET = '/services/getPromotions';
export const RESERVATIONS_GET_PRICING = '/reservations/getPricing';
export const RESERVATION_GROUPS_GET = '/reservationGroups/get';
export const RESERVATIONS_PRICE = '/reservations/price';
export const RESERVATION_GROUPS_CREATE = '/reservationGroups/create';
export const PRODUCTS_GET_PRICES = '/products/getPrices';
export const SERVICE_DOCUMENTS_GET_ALL = '/serviceDocuments/getAll';
export const SERVICES_GET_AVAILABILITY = '/services/getAvailability';
export const SERVICES_GET_PRICING = '/services/getPricing';
